import { Box, Button, Flex } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import scroll from "scroll"
import scrollDoc from "scroll-doc"
import styled from "styled-components"

import {
  addFinalDiamond,
  diamondNextStep,
  diamondPrevStep,
  updateDiamond,
} from "areas/product/store/actions"

const Cta = styled(Button).attrs((props) => ({
  ...props.theme.diamondSelector.navigateNext,
}))``

const BackBtn = styled(Cta).attrs((props) => ({
  ...props.theme.diamondSelector.navigateBack,
}))``

const InternalNavigation = ({
  addDiamond,
  currentStep,
  currentStepName,
  disableNext,
  goNext,
  goPrev,
  selectedTmpDiamond,
  showNextStep,
}) => {
  let disableNextStep = disableNext
  const buildOwnPath = ["d_cut", "d_color", "d_clarity"].includes(
    currentStepName
  )
  if (buildOwnPath && !selectedTmpDiamond[currentStepName]) {
    disableNextStep = true
  }
  return (
    <Flex gutter="6px" justifyContent="space-between" mb={3}>
      {currentStep > 0 && (
        <Box flex="1" maxWidth="50%">
          <BackBtn onClick={() => goPrev()}>Back</BackBtn>
        </Box>
      )}
      {["choose_stone", "confirm_stone", "confirm_gemstone"].includes(
        currentStepName
      ) ? (
        <Box flex="1" textAlign="right">
          <Cta
            data-cy="diamon-selector-navigation-confirm-stone"
            disabled={
              currentStepName === "choose_stone"
                ? !selectedTmpDiamond.stone_code
                : !selectedTmpDiamond.price
            }
            onClick={() => addDiamond(selectedTmpDiamond)}
          >
            Confirm Stone
          </Cta>
        </Box>
      ) : showNextStep ? (
        <Box flex="1" textAlign="right">
          <Cta
            data-cy="diamon-selector-navigation-next"
            disabled={disableNextStep}
            onClick={() => goNext()}
          >
            Next
          </Cta>
        </Box>
      ) : (
        <div />
      )}
    </Flex>
  )
}

const mapStateToProps = (state) => {
  const currentStepName = state.diamondUI.steps[state.diamondUI.currentStep]
  let disableNext = false
  if (["d_shape", "d_carat"].includes(currentStepName)) {
    const selectedChoice = state.choices[currentStepName]?.value
    disableNext = !state.diamondSelector[currentStepName]?.options.some(
      (o) => o.value === selectedChoice
    )
  }
  return {
    currentStep: state.diamondUI.currentStep,
    currentStepName,
    disableNext,
    recommendedStones: state.diamondSelector.recommended_stones,
    selectedTmpDiamond: state.diamondUI.tmpDiamond,
    showNextStep:
      state.diamondUI.currentStep < state.diamondUI.steps.length - 1,
  }
}

const mapDispatchToProps = (dispatch) => {
  return { dispatch }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { currentStepName, recommendedStones, selectedTmpDiamond } = stateProps
  const { dispatch } = dispatchProps
  const { diamondSelectorRef } = ownProps

  const scrollSelectorInView = () => {
    if (diamondSelectorRef.current) {
      const offset = diamondSelectorRef.current.offsetTop - 120
      const page = scrollDoc()
      if (scrollY > offset) {
        scroll.top(page, offset)
      }
    }
  }

  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    addDiamond: () => {
      if (currentStepName === "confirm_stone") {
        dispatch(updateDiamond("final_diamond"))
      } else {
        let tmpDiamond = selectedTmpDiamond
        if (typeof selectedTmpDiamond.recommendedIndex !== "undefined") {
          tmpDiamond =
            recommendedStones[selectedTmpDiamond.recommendedIndex].stone
        }
        dispatch(addFinalDiamond(tmpDiamond))
      }
      scrollSelectorInView()
      dispatch(diamondNextStep())
    },
    goNext: () => {
      scrollSelectorInView()
      dispatch(diamondNextStep())
    },
    goPrev: () => {
      dispatch(diamondPrevStep())
    },
  }
}

InternalNavigation.propTypes = {
  addDiamond: PropTypes.func,
  currentStep: PropTypes.number,
  currentStepName: PropTypes.string,
  diamondSelectorRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  disableNext: PropTypes.bool,
  goNext: PropTypes.func,
  goPrev: PropTypes.func,
  selectedTmpDiamond: PropTypes.object,
  showNextStep: PropTypes.bool,
}

const Navigation = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(InternalNavigation)

export default Navigation
